import { ReactNode } from 'react';

import { cn } from '../../../../../lib/utils';

export type PillVariant = 'display' | 'selectable' | 'add';

export interface PillProps {
    variant?: PillVariant;
    isSelected?: boolean;
    onClick?: () => void;
    title?: string;
    className?: string;
    children: ReactNode;
}

const VARIANT_CLASSES: Record<PillVariant, string> = {
    display: 'border-secondary bg-muted/50 text-muted-foreground',
    selectable:
        'cursor-pointer border-secondary bg-muted/50 text-muted-foreground hover:bg-muted hover:text-foreground',
    add: 'cursor-pointer border-dashed border-primary/20 text-muted-foreground/60 hover:border-(--group-color)/60 hover:bg-(--group-color)/20 hover:text-foreground',
};

const SELECTED_CLASSES = 'border-(--group-color) bg-(--group-color)/20 text-foreground';

export function Pill({ variant = 'display', isSelected, onClick, title, className, children }: PillProps) {
    return (
        <div
            className={cn(
                'group/pill inline-flex items-center gap-1 whitespace-nowrap rounded-full',
                'border px-2 py-0.5 text-[10px] transition-colors duration-200',
                VARIANT_CLASSES[variant],
                isSelected && SELECTED_CLASSES,
                className
            )}
            onClick={onClick}
            title={title}
        >
            {children}
        </div>
    );
}
